import React from 'react';
import { Navigate, Params, useParams } from 'react-router-dom';

import { getBatchSheetURL } from '~/lib/transfers/utils';

export const PageTransferBatchesView: React.FC = () => {
  const { transferBatchId } = useParams<keyof Params>() as Params;

  return <Navigate to={getBatchSheetURL(transferBatchId ?? '')} replace />;
};
